export default (state, { payload }) => ({
    ...state,
    event: payload,
    error: null,
    ticketTypes: payload.ticket_types.reduce((accumulator, ticketType) => {
        accumulator[ticketType.hash] = {
            ...ticketType,
            price_types: ticketType.price_types.map(priceType => priceType.hash),
        };
        return accumulator;
    }, {}),
    priceTypes: payload.ticket_types.reduce((accumulator, ticketType) => {
        ticketType.price_types.forEach((priceType) => {
            accumulator[priceType.hash] = priceType;
        });
        return accumulator;
    }, {}),
});
